export default {
  banner: {
    joinReferral: 'เข้าร่วม Cookie Wow Referral Program',
    justShare: 'สร้างรายได้ง่าย ๆ เพียงแค่แชร์!',
    joinNow: 'เข้าร่วมเลย!',
  },
}
